import View from "./View";
import Edit from "./Edit";
import { DraftjsProps } from "Core/types/Draftjs";

const DraftjsEditor: React.FC<DraftjsProps> = (props) => {
  return props.disabled || !props.onChange ? <View value={props.value} /> : <Edit {...props} />;
};

export default DraftjsEditor;
